// removed by extract-text-webpack-plugin
module.exports = {"binary_panel_container":"_3HV3DBFdBc-leZPvl1i_OE","binary_panel":"_2eSuf3yIcbeZGOHgoTg_4i"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryPanel/BinaryPanel.scss
// module id = 2153
// module chunks = 1